module.exports = __webpack_public_path__ + "static/icon_mail-425df76262e4e7e11a4bad6d0bc3161e.png";